import * as firebase from "firebase";

let config = {}

if (process.env.NODE_ENV == 'development') {
  // Development config
  config = {
    // apiKey: "AIzaSyAUl6Wv-8YmrAVUSqDPSa8Q_tZQqnBP8y4",
    // authDomain: "test-project-c8960.firebaseapp.com",
    // databaseURL: "https://test-project-c8960.firebaseio.com/"
    apiKey: "AIzaSyDf4ijfrMkX3oOp8Og-5VZIC-HpLQ6RyEw",
    authDomain: "cnmtco-test.firebaseapp.com",
    databaseURL: "https://cnmtco-test.firebaseio.com"
    // storageBucket: "gs://test-project-c8960.appspot.com"
  };
} else {
  // Production config
  config = {
    apiKey: "AIzaSyA1TTNNT0Zji1FBLIsedWRCa1rMbCMdX7s",
    authDomain: "cnmt.co",
    databaseURL: "https://cnmtco.firebaseio.com/"
  }
}

const fire = firebase.initializeApp(config);

export default fire;


// WEBPACK FOOTER //
// ./src/config/fire.js